import PropTypes from 'prop-types';
import React from 'react';

import Image from '../../atoms/image/image';
import Headline from '../../atoms/headline/headline';
import MixedCopy from '../mixed-copy/mixedCopy';

import StyledImageText from './imageText.style';
import Copy from '../../atoms/copy/copy';

const sizes = [
  {
    condition: 'min-width: 980px',
    width: '30vw'
  },
  {
    condition: 'min-width: 450px',
    width: '45vw'
  },
  {
    width: '100vw'
  }
];

const ImageText = ({
  alignment = 'left',
  file,
  imageLink,
  isExternalLink = false,
  caption,
  credits,
  headline,
  subline,
  copy,
  hasBackground = true
}) => {
  const ImageWrapperTag = imageLink ? 'a' : 'div';

  return (
    <StyledImageText
      alignment={alignment}
      hasHeadlines={subline || headline}
      imageFormat={file.imageFormat}
      hasBackground={hasBackground}
    >
      {(subline || headline) && (
        <div className="text__headlines">
          {subline && (
            <Headline tag="h3" subline>
              {subline}
            </Headline>
          )}
          {headline && <Headline secondary>{headline}</Headline>}
        </div>
      )}

      <div className="content__container">
        <div className="image__background image__background--desktop" />
        <MixedCopy className="text__copy" fullWidth html={copy} />
        <div className="image__container">
          <figure>
            <div className="image__wrapper">
              <div className="image__background image__background--mobile" />
              <div className="image__outer">
                <ImageWrapperTag
                  className="image__inner"
                  href={imageLink && imageLink}
                  title={imageLink && file.caption}
                  target={isExternalLink && '_blank'}
                  rel={isExternalLink && 'noopener noreferrer'}
                >
                  <Image {...file} lazy="default" sizes={sizes} />
                </ImageWrapperTag>
              </div>
            </div>

            <div className="image__description">
              {(caption || file.caption) && (
                <Copy
                  tag="figcaption"
                  className="image__caption"
                  small
                  dangerouslySetInnerHTML={{ __html: caption || file.caption }}
                />
              )}

              {(credits || file.credits) && (
                <Copy
                  tag="figcaption"
                  className="image__credits"
                  small
                  dangerouslySetInnerHTML={{ __html: credits || file.credits }}
                />
              )}
            </div>
          </figure>
        </div>
      </div>
    </StyledImageText>
  );
};

ImageText.propTypes = {
  alignment: PropTypes.oneOf(['left', 'right']),
  file: PropTypes.shape({
    imageFormat: PropTypes.oneOf(['portrait', 'landscape']),
    caption: PropTypes.string,
    credits: PropTypes.string
  }).isRequired,
  imageLink: PropTypes.string,
  isExternalLink: PropTypes.bool,
  caption: PropTypes.string,
  credits: PropTypes.string,
  headline: PropTypes.string,
  subline: PropTypes.string,
  copy: PropTypes.string.isRequired,
  hasBackground: PropTypes.bool
};

export default ImageText;
